<template>
    <div class="table-container"
        :class="{'px-3 py-2' : $breakpoint.lgAndDown}">
        <table class="table responsive-table" @click="goToManageOffers()">
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(day, key) in dayAvailabilityStatusList" :key="key" class="text-center">
                        <div> 
                            <p>{{day.start}}</p>
                            <p>{{day.end}}</p>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>Terminal</th>
                    <th v-for="(day, dayIndex) in daysList" :key="dayIndex" class="text-center">
                        {{day | daydateformat}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="terminalSettings.length < 1" >
                    <td colspan="7">Upload a delivery file to see Delivered in terminals</td>
                </tr>
                <tr v-else v-for="(terminal,key) in terminalSettings" 
                    class="offer-rows" :key=key
                >
                    <th 
                        :class="{'heading-medium' : $breakpoint.mdAndDown}"
                    >
                        {{terminal.terminal.name}}
                    </th>
                    <td :label="daysList[dayIndex] | daydateformat" 
                        v-for="(day, dayIndex) in terminalSettingsPerDay[key]" :key="dayIndex"
                        :class="[$breakpoint.mdAndDown ? 'd-flex justify-content-between align-items-center' : 'text-center']"
                    >
                        <div v-if="$breakpoint.mdAndDown" class="d-flex justify-content-start w-100">
                            <div class="mr-2">{{dayAvailabilityStatusList[dayIndex].start}}</div>
                            <div>- {{dayAvailabilityStatusList[dayIndex].end}}</div>
                        </div>
                        <i v-if="day.enabled && dayAvailabilityStatusList[dayIndex].enabled && !toggleStates[dayIndex] && toggleAllOffers && terminal.enabled" class="fas fa-circle text-primary"></i>
                        <i v-else class="fas fa-circle text-danger"></i>
                    </td>
                </tr>  
            </tbody>
        </table>
    </div>
</template>
<script>

import {mapState,mapActions,mapGetters, mapMutations } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data:function(){
        return{
            checkedTogglesList:[],
            terminals: [],
            times: [],
            terminalSettingsPerDay: [],
            terminalSettings:[],
            dayAvailabilityStatusList: [],
            parsedAvailabilityTimes: [],
            timeParsed:false,
            timerForRefresh:""
        }
    },
    created(){
        this.getOffersTimeAvailability().then(() => {
            if(this.offersAvailability.deliveredIn){
                this.toggleAllOffers = this.offersAvailability.deliveredIn.enabled
                this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['one']))
                this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['two']))
                this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['three']))
                this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['four']))
                this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['five']))
            } 
        })
        this.getHaulageTerminalSettings()
    }, 
    methods:{
        ...mapActions('sellerOffers',['getOffersTimeAvailability']),
        
        goToManageOffers: function(){
            this.tabSelected.tabIndex = 2
            this.$router.push('/manageOffers/deliveredIn')
        },
        getDayIndex: function(dayIndex){
            switch (dayIndex){
                case 0:
                    return 'one'
                case 1:
                    return 'two'
                case 2:
                    return 'three'
                case 3:
                    return 'four'
                case 4:
                    return 'five'
            }
        },
        getHaulageTerminalSettings: async function(){
            this.terminalSettingsPerDay = []
            const haulierAccountId = this.userLoggedIn.id
            const response = await this.axios.get('/api/getHaulageTerminalSettings', {params: {haulierAccountId}})
            if (response.data.success){
                this.terminalSettings = response.data.terminalSettings
                this.terminalSettings.forEach((terminal, index) => {
                    let arr = [ 
                        terminal.days['one'],
                        terminal.days['two'],
                        terminal.days['three'],
                        terminal.days['four'],
                        terminal.days['five'],
                    ]
                    this.terminalSettingsPerDay.push(arr)
                })
            }
        }, 
        countdownForRefreshingToggles: function(){
            const now = Date.parse(new Date())
            const future = this.parsedAvailabilityTimes.filter(time => time > now);
            const min = Math.min.apply(null, future)
            const diff = (min - now) +2000
            this.timerForRefresh = setTimeout(() => { 
                this.timeParsed = true
            }, diff);             
        },
        formatStartTime: function(i){
            const dayIndex = this.getDayIndex(i)
            const startingHour = this.offersAvailability.deliveredIn.days[dayIndex].start.substring(0, 2)
            const startingMinute = this.offersAvailability.deliveredIn.days[dayIndex].start.substring(3)
            const startTime = new Date().setHours(startingHour, startingMinute, 0)
            return startTime
        },
        formatEndTime: function(i){
            const dayIndex = this.getDayIndex(i)
            const endHour = this.offersAvailability.deliveredIn.days[dayIndex].end.substring(0, 2)
            const endMinute = this.offersAvailability.deliveredIn.days[dayIndex].end.substring(3)
            const endTime = new Date().setHours(endHour, endMinute, 0)
            return endTime
        }
    },
    computed:{
        ...mapState('login', ['userLoggedIn']),
        ...mapState('sellerOffers',['offersAvailability']),
        ...mapState('sellerTabs',['tabSelected']),
        daysList: {
            get: function(){
                const moment = require('moment');
                const momentBusiness = require('moment-business-days');

                const today = moment().format('DD-MM-YYYY');
                let days = []

                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(1)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(2)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(3)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(4)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(5)._d)

                return days
            }
        },
        toggleStates:{
            get: function(){
                this.parsedAvailabilityTimes= []
                let disabledStatuses = []
                const currentTime = new Date()
                if (this.offersAvailability || this.timeParsed){
                    if (this.offersAvailability.deliveredIn.days){
                        for (let i = 0; i < Object.keys(this.offersAvailability.deliveredIn.days).length; i++){
                            const startTime = this.formatStartTime(i)
                            const endTime = this.formatEndTime(i)
                            this.parsedAvailabilityTimes.push(startTime)
                            this.parsedAvailabilityTimes.push(endTime)
                            if (currentTime < startTime || endTime <= currentTime){
                                disabledStatuses[i] = true
                            }
                            else {
                                disabledStatuses[i] = false
                            }
                        }
                        if(!this.timeParsed){
                            this.countdownForRefreshingToggles()
                        }else{
                            this.timeParsed=false
                        }
                    }
                }
                return disabledStatuses
            }
        }
    },
}
</script>